import { StateCreator, StoreApi } from 'zustand';
import { Actions } from './filters.model';
import { FiltersStore, initialState } from './filters.model';
import { OperationType } from '../../../../ResourceMapper/types';

const actions = (
  set: StoreApi<FiltersStore>['setState'],
  get: StoreApi<FiltersStore>['getState'],
): Actions => ({
  setDateRange: (values) =>
    set({ dateRange: { start: values ? values[0] : null, end: values ? values[1] : null } }),
  setOperationsType: (value) => {
    if (value === OperationType.ALL) {
      set({ operationTypes: [OperationType.ALL] });
      return;
    }
    if (get().operationTypes.includes(value)) {
      set(({ operationTypes }) => ({
        operationTypes: operationTypes.filter(
          (type) => type !== value && type !== OperationType.ALL,
        ),
      }));
      return;
    }
    set(({ operationTypes }) => ({
      operationTypes: [...operationTypes, value].filter((type) => type !== OperationType.ALL),
    }));
  },
});

export const createFiltersSlice: StateCreator<FiltersStore> = (set, get) => ({
  ...initialState,
  ...actions(set, get),
});

export type FiltersSlice = ReturnType<typeof createFiltersSlice>;
